/* global $ */
/* eslint no-unused-vars: 0 */

const $html = $('html');
const $moblieNavOverlay = $.$body.find('.mobile-nav-overlay');
const $menuOverlayControls = $.$body.find('.js-mobile-menu-control');
const $openText = $.$body.find('.hamburger-control__open-label');
const $closeText = $.$body.find('.hamburger-control__close-label');
let lastScrollPosition = 0;

const openMenu = ($menu) => (e) => {
  // console.log($menu, e.currentTarget);
  e.preventDefault();
  $menuOverlayControls.addClass('is-active');
  $openText.hide().attr('aria-hidden', false);
  $closeText.show().attr('aria-hidden', true);
  lastScrollPosition = $('html, body').scrollTop();
  $menu.addClass('menu--open temp-high-z');
  $html.addClass('overlay-active mobile-menu-active');
  $menu.find('.mobile-overlay__inner').scrollTop(0);
  $menu.attr('aria-hidden', false);
};

const closeMenu = ($menu, cancelEvent) => (e) => {
  $menuOverlayControls.removeClass('is-active');
  $html.removeClass('overlay-active mobile-menu-active');
  $menu.removeClass('menu--open');
  $openText.show().attr('aria-hidden', true);
  $closeText.hide().attr('aria-hidden', false);
  if (cancelEvent && e) {
    e.preventDefault();
    e.stopPropagation();
  }
  $menu.attr('aria-hidden', true);
  // $('html, body').animate({ scrollTop: lastScrollPosition }, 50);
  setTimeout(() => {
    // eslint-disable-line
    $menu.removeClass('temp-high-z');
  }, 200);
};

$.$body
  .on('click', '.js-open-main-menu', openMenu($moblieNavOverlay))
  .on(
    'click',
    '.js-close-main-menu,.js-open-main-menu.is-active',
    closeMenu($moblieNavOverlay),
  );

// close on ESC
document.addEventListener(
  'keyup',
  (ev) => ev.keyCode === 27 && closeMenu($moblieNavOverlay)(),
);
